var path = '/templates/zenclerk_s/sites/terminated/terminated.html';
var html = "<div class=container-fluid><div class=terminated><h1>{{ 'sites.terminated.terminated.you' | translate: { name: $ctrl.project.title } }}</h1></div><div class=text-center ng-if=$ctrl.project.is_terminated>{{ 'sites.terminated.terminated.yori_kaiyaku_sareteimasu' | translate: { date: $ctrl.terminatedDate } }}<br>{{ 'sites.terminated.terminated.saabisu_wo_saikai' | translate }}</div><div class=text-center ng-if=!$ctrl.project.is_terminated>{{ 'sites.terminated.terminated.saabisu_wo_go' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/terminated/terminated.html
// module id = 1443
// module chunks = 0